/* eslint-disable */

const defaultConfig = {
  thousandSeparated: true,
  digits: 0
}

/**
 * Format numbers
 *
 * @param  {number} value
 * @param  {number} digits
 * @return {size}
 */
export const numeric = (value, config = {}) => {
  if (Number.isInteger(config)) {
    config = { digits: config }
  }

  const { thousandSeparated, digits } = { ...defaultConfig, ...config }
  let n = Number(value).toFixed(digits).toString()

  if (thousandSeparated) {
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  return n
}
